<style lang="sass" scoped>
a
  color: #777
  border-radius: 5px
  transition: background-color 0.2s
  &:hover
    background-color: #f0f0f0
    text-decoration: none
</style>
<template>
  <div class="text-left mx-1 d-block">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "DropdownBlock",
  // met
};
</script>
